import Typography from '@mui/material/Typography'
import { BorderContainer } from '../borderedContainer'

export const Unknown = () => (
  <BorderContainer
    aria-label="unknown"
    sx={{
      gap: 1,
    }}
  >
    <Typography
      variant="body1"
      sx={{
        fontWeight: 600,
      }}
    >
      Unsupported country
    </Typography>
    <Typography
      variant="body2"
      sx={{
        color: 'text.secondary',
      }}
    >
      Creating mandates is not supported for this customer
    </Typography>
  </BorderContainer>
)
